import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);

const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 10000,
    rejectUnauthorized: false, 
})

instance.interceptors.request.use(config => {
    if (config.method === "post") {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    }

    if (localStorage.getItem('token')) {
        config.headers['token'] = Base64.encode(localStorage.getItem('token'));
    }

    // config.headers['lang'] = 'zh_cn';
    // var yvyan = localStorage.getItem('lang');
    // if (yvyan) {
    //     config.headers['lang2'] = yvyan;
    // } else {
    //     config.headers['lang2'] = 'ko_hy';
    // }
    const currentLang = localStorage.getItem('lang') || 'zh_tw';
    config.headers['lang'] = currentLang
    return config;
}, err => {
    console.error('请求失败', err);
});

instance.interceptors.response.use(res => {
    if (res.data.msg === "鉴权错误") {
        localStorage.clear();
        location.href = '/Login';
    }
    return res;
}, err => {
    return Promise.reject(err);
});

async function http(option = {}) {
    let result = null;
    try {
        if (option.method === 'get' || option.method === 'delete') {
            let res = await instance[option.method](api[option.url], { params: option.data });
            result = res.data;
            result.data = JSON.parse(Base64.decode(result.data));
        } else if (option.method === 'post' || option.method === 'put') {
            let res = await instance[option.method](api[option.url], qs.stringify(option.data));
            result = res.data;
            result.data = JSON.parse(Base64.decode(result.data));
        }
    } catch (err) {
        result = err;
    }
    return result;
}

export default http;
